const doc = [({"da":({"js":({"admin":({"bundles":({"show":({"show_bundle_name":"Vis bundle: %{name}"})})})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;